exports.init = function ModalOnboarding() {
  const $modal = $('#modal-onboarding');

  $modal.one('show.bs.modal', function(e) {
    const $salvar = $modal.find('#salvar');
    const $form = $modal.find('#onboarding-form');
    const $cancelar = $modal.find('#cancelar');
    const ajax = function(data) {
      nifty.body.overlay('show');
      return $.ajax({
        method: 'POST',
        url: route('app.settings.save-user-params'),
        data: data,
        complete: function(){
          nifty.body.overlay('hide');
          $modal.modal('hide');

        }
      });
    }

    $salvar.on('click', function() {
      ajax($form.serialize());
    });

    $cancelar.on('click', function() {
      ajax(null);
    });

  });
};
